import { useContext, useState } from "react";
import { Option } from "../../../../components/shared/selectInput/types/selectInputProps";
import KrFormContext, { KrFormContextLandslideType, NavHeadingsKROEnum } from "../../../../contexts/krFormContext";
import SelectForTextField from "../../../../components/selectForTextField/selectForTextField";
import TextAreaField from "../../../../components/textAreaField/textAreaField";
import { TextAreaFieldProps } from "../../../../components/textAreaField/types/textAreaFieldProps";
import { SelectForTextFieldProps } from "../../../../components/selectForTextField/types/selectForTextFieldProps";
import { styleFormFieldSeventyFive } from "../../../../components/shared/stylization";
import { classNameBtn, iconPosition } from "../../../../components/shared/button/types/buttonProps";
import { ReactComponent as addCircleIcon } from '../../../../icons/add_circle.svg';
import { FormSectionProps } from "./shared/types/formSectionProps";
import { createConfigValidation } from "../../../../helpers/validation/validation";
import CollectiveSelectField from "../../collectiveEditionView/collectiveField/collectiveSelectField";
import { CollectivePreviewKey } from "../../../../helpers/collective/preview";
import { LabelChipClassType } from "../../../../components/shared/labelChip/types/labelChipProps";
import { getAddCommentBtnDetails, getFieldRef, getItemRef } from "../../../../helpers/form";
import { KROFieldDict } from "../../shared/commentsSidebar/fieldDict";

const SecurityOptions = (props: FormSectionProps) => {

    const Options: Option[] = [
        { name: 'Zabezpieczenie osuwiska jest możliwe. W przypadku zamiaru stabilizacji osuwiska, wykonania innych prac zabezpieczających lub wykonania inwestycji na obszarze osuwiska, należy najpierw sporządzić dokumentację geologiczno-inżynierską.', value: '1' },
        { name: 'Zabezpieczenie osuwiska w całości może być trudne, ze względu na jego rozmiar, głębokość występowania powierzchni poślizgu oraz uwarunkowania geologiczne. W przypadku zamiaru stabilizacji osuwiska, wykonania innych prac zabezpieczających lub wykonania inwestycji na obszarze osuwiska, należy najpierw sporządzić dokumentację geologiczno-inżynierską.', value: '2' },
        { name: 'Na osuwisku zostały wykonane  prace stabilizacyjne. W przypadku zamiaru wykonania kolejnych inwestycji na obszarze osuwiska, należy najpierw sporządzić dokumentację geologiczno-inżynierską', value: '3' },
        { name: 'Przed wykonaniem inwestycji powinna zostać wykonana ocena jej opłacalności.', value: '4' },
        { name: 'Zabezpieczanie osuwiska jest niecelowe ze względów ekonomicznych, gdyż obecnie nie zagraża ono żadnym budynkom ani elementom infrastruktury.', value: '5' },
        { name: 'Podczas robót geologicznych należy określić głębokość najniżej występującej powierzchni poślizgu w obrębie osuwiska, potwierdzając to wynikami prac wiertniczych (wiercenia rdzeniowane z uzyskaniem rdzenia o nienaruszonej strukturze).', value: '6' },
    ]

    const { krForm, setkrForm } = useContext(KrFormContext) as KrFormContextLandslideType;

    const [selectedDescript, setSelectedDescript] = useState(Options[0]);
    const [description, setDescription] = useState(Options[0].name);
    const [pristineInformacje, setPristineInformacje] = useState(true);

    const isFormNotValid = krForm.config?.isValid !== undefined ? !krForm.config?.isValid : false;

    var textAreaProps: TextAreaFieldProps = {
        labelName: '',
        textAreaPlaceholder: 'Dodaj opis',
        value: krForm.landslideAttributes?.uwagi,
        textareaSharedProps: {
            className: krForm.landslideAttributes?.uwagi == null
                || krForm.landslideAttributes?.uwagi === '' ?
                'body-txt-medium-sec-gray' :
                'body-txt-large',
            style: {
                width: '100%',
                minHeight: '70px'
            }
        },
        configValidation: props.collectiveEdition ? undefined : createConfigValidation("uwagi"),
        disabled: !props.editMode,
        pristine: pristineInformacje,
        setValue: (value: any) => {
            var form = Object.assign({}, krForm);
            if (form && form.landslideAttributes) {
                form.landslideAttributes.uwagi = value;
                setkrForm(form);
            }
        },
        validationError: isFormNotValid,
        addCommentBtn: getAddCommentBtnDetails(props.editMode!, KROFieldDict.infoZabezp_informacjeOMozliwosciZabezpieczenia, "Informacje o możliwości zabezpieczenia oraz informacje dodatkowe", props.setNewCommentFieldDetails!),
        textareaRef: (node: any) => {getFieldRef(node, KROFieldDict.infoZabezp_informacjeOMozliwosciZabezpieczenia, props.getMapForComment!)},
        setCommentsFilter: () => { if(props.setCommentsFilter) props.setCommentsFilter(KROFieldDict.infoZabezp_informacjeOMozliwosciZabezpieczenia); },
        isMarkedForCommentFilter: props.markedFieldForCommentFiltering === KROFieldDict.infoZabezp_informacjeOMozliwosciZabezpieczenia,
        dynamicResize: true
    }

    const selectOptionChange = (option: Option | Option[]) => {
        if (option) {
            const opt = option as Option;
            if (opt.name) {
                setDescription(opt.name);
                setSelectedDescript(opt);
            }
        }
    }

    const onClickButton: React.MouseEventHandler<HTMLButtonElement> = (event) => {
        var form: any = Object.assign({}, krForm);
        if (form.landslideAttributes.uwagi == null) {
            form.landslideAttributes.uwagi = "";
        }
        form.landslideAttributes.uwagi += description;
        setkrForm(form);
        setPristineInformacje(false);
    }

    const selectForTextProps: SelectForTextFieldProps = {
        selectInputProps: {
            style: styleFormFieldSeventyFive,
            label: 'Szablon',
            options: Options,
            selectedSingleOption: selectedDescript,
            onChange: selectOptionChange
        },
        buttonProps: {
            BtnProps: {
                onClick: onClickButton,
                className: classNameBtn.SmallSecondary + " body-txt-medium",
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    width: '100%'
                }
            },
            placeHolder: "Dodaj treść z szablonu",
            placeHolderStyle: {
                paddingLeft: '25px'
            },
            additionalIcon: addCircleIcon,
            iconPosition: iconPosition.Start,
            wrapperProps: {
                style: {
                    width: '28%',
                    display: 'flex',
                    height: '49px',
                    paddingTop: '30.5px'
                }
            }
        }
    }

    if (props.collectiveEdition) {
        return (
            <>
                <h2 style={{ width: '100%' }}>17. Informacje o możliwości zabezpieczenia oraz informacje dodatkowe</h2>
                <CollectiveSelectField top={true} value={krForm.landslideAttributes?.uwagi} isAuto={false} title={"Informacje o możliwości zabezpieczenia oraz informacje dodatkowe"}
                    forms={props.forms} keyName={CollectivePreviewKey.uwagi} actions={props.actions} single={true} labelClass={LabelChipClassType.Checkbox} preventAdd={false}
                    setActions={props.setActions} onDelete={props.onDelete}>
                    <TextAreaField {...textAreaProps} />
                </CollectiveSelectField>
                <div className='collective-input-container collective-block'>
                    <SelectForTextField {...selectForTextProps} />
                </div>
            </>
        )
    }

    return (
        <>
            <h2 ref={(node) => getItemRef(node, NavHeadingsKROEnum.SecurityOptions, props.getMapForNavScroll!)} style={{ width: '100%' }}>
                {props.version === 1 ? "17. Uwagi o możliwości zabezpieczenia oraz dodatkowe informacje" : 
                                    "17. Informacje o możliwości zabezpieczenia oraz informacje dodatkowe"}
            </h2>
            <TextAreaField {...textAreaProps} />
            {props.editMode && <SelectForTextField {...selectForTextProps} />}
        </>
    )
}

export default SecurityOptions;